module.exports = __webpack_public_path__ + "img/ic_data_privacy.b002b3c6.svg";